import React from 'react';
import { Bar, FilledBar } from './ProgressBar.styles';
import {} from './ProgressBar.types';
const ProgressBar = ({ percentage = 0 }) => (React.createElement(Bar, null,
    React.createElement(FilledBar, { percentage: percentage })));
export default ProgressBar;
